import { forwardRef } from "react";
import { PlusIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

// Unified "create / new" entry button: a plus icon + label. Forwards ref so it
// can also be used as a Dialog/Popover trigger via asChild.
type Props = { label: string } & React.ComponentProps<typeof Button>;

export const CreateEntryButton = forwardRef<HTMLButtonElement, Props>(
  ({ label, className, size = "sm", variant = "default", type = "button", ...rest }, ref) => (
    <Button
      ref={ref}
      type={type}
      size={size}
      variant={variant}
      className={cn("gap-2", className)}
      {...rest}
    >
      <PlusIcon className="h-3.5 w-3.5" />
      {label}
    </Button>
  ),
);
CreateEntryButton.displayName = "CreateEntryButton";

export default CreateEntryButton;
